'use strict';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  notifications: {
    chats: {},
    emails: {},
    telephony: {},
    system: {
      messages: [],
      unread: 0
    },
    callbacks: []
  }
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
};
